// extracted by mini-css-extract-plugin
module.exports = {"mainPhoto":"_2Q9lm","container":"IFPon"};